import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  communicationSettingsService,
  CommunicationRedirectSettings,
  UpdateCommunicationRedirectSettingsRequest,
} from "../../services/admin/communicationSettings.service";

export const COMMUNICATION_REDIRECT_SETTINGS_QUERY_KEY = [
  "communication-redirect-settings",
] as const;

export function useCommunicationRedirectSettings(enabled = true) {
  return useQuery({
    queryKey: COMMUNICATION_REDIRECT_SETTINGS_QUERY_KEY,
    queryFn: communicationSettingsService.getRedirectBypassPrefixes,
    staleTime: 30_000,
    enabled,
  });
}

export function useUpdateCommunicationRedirectSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: UpdateCommunicationRedirectSettingsRequest) =>
      communicationSettingsService.updateRedirectBypassPrefixes(request),
    onSuccess: (settings: CommunicationRedirectSettings) => {
      queryClient.setQueryData(
        COMMUNICATION_REDIRECT_SETTINGS_QUERY_KEY,
        settings
      );
      queryClient.invalidateQueries({
        queryKey: COMMUNICATION_REDIRECT_SETTINGS_QUERY_KEY,
      });
      queryClient.invalidateQueries({ queryKey: ["communication-logs"] });
    },
  });
}
